<div class="report-page-root-container  hourly-sales-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg> -->
      <img class="icon" src="assets/images/menu/svg/hourly-sales-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details" style="overflow: hidden;">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Period From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Period To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.hasError('required') && editForm.get('period_to')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <mat-form-field>
                  <mat-label>Period To</mat-label>
                  <mat-select placeholder="Select a year" formControlName="period_to" (selectionChange)="onYearChange()">
             

                    <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                      {{ fy.display_year }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
            <!-- <div class="input-box-right">
                <mat-form-field class="Week-NO">
                  <mat-label>Week No</mat-label>
                  <mat-select formControlName="week_no">
                    <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                      {{ week.displayText }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            <!-- Department From Dropdown -->
            <div class="list-row departments">
              <div class="header" (click)="isExpandedDepartment = !isExpandedDepartment">
                <div class="title-container">
                  <span class="title">Department</span> <span class="count" *ngIf="selectedDepartmentSourcesCount>0">[
                    {{selectedDepartmentSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedDepartment">
                    <button type="button" class="list-action-button" mat-icon-button
                      (click)="$event.stopPropagation(); showSelectedDepartmentOnly = !showSelectedDepartmentOnly"
                      [matTooltip]="showSelectedDepartmentOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedDepartmentOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button" mat-icon-button
                      (click)="$event.stopPropagation(); toggleSelectAllDepartment()" matTooltip="Select All/None">
                      <mat-icon>{{ getSelectAllIconDepartment() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedDepartment = !isExpandedDepartment">
                    <mat-icon>{{ isExpandedDepartment ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedDepartment" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Department" formControlName="departmentFilter">
                      <button *ngIf="editForm.get('departmentFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('departmentFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredDepartmentListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onShopSelectionChange()">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected"
                            (change)="item.selected = !item.selected; onShopSelectionChange()"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="input-box-left">
                <div class="day">Day</div>
              </div>
              <div class="input-box-right" formGroupName="days">
                <mat-checkbox *ngFor="let day of daysOfWeek" [formControlName]="day" style="display: inline-block;
    margin: 5px;
    padding: 5px 12px;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.3s ease;">
                  {{ day }}
                </mat-checkbox>
              </div>
            </div>
            <!-- <div class="input-group">
              <div>
                Exclude sales details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>

              </div>

            </div> -->
            <!-- <div class="input-group">
              <div>
                Exclude expenses details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>
              </div>

            </div> -->
            <div class="row">
              <mat-form-field style="width: 250px;">
                <mat-label>Percentage Calculation</mat-label>
                <mat-select formControlName="percentage_calculation">
                  <mat-option [value]="0">
                    Total Sales Amount
                  </mat-option>
                  <mat-option [value]="1">
                    Total Units Sold
                  </mat-option>
                </mat-select>

              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>From (Hours)</mat-label>
                <mat-select formControlName="fromHour">
                  <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                </mat-select>
                <mat-error *ngIf="editForm.get('fromHour')?.hasError('required') && editForm.get('fromHour')?.touched">
                  From hour is required
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>To (Hours)</mat-label>
                <mat-select formControlName="toHour">
                  <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                </mat-select>
                <mat-error *ngIf="editForm.get('toHour')?.hasError('required') && editForm.get('toHour')?.touched">
                  To hour is required
                </mat-error>
              </mat-form-field>
              <div *ngIf="editForm.errors?.['invalidHourRange'] && editForm.touched" class="error">
                Invalid time duration.
              </div>

            </div>
            <div style="margin-top: 8px;margin-left: 15px;">

              <mat-checkbox formControlName="summary_report">Summary Report</mat-checkbox>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>